import { render, staticRenderFns } from "./AdminPurchaseOrderItemModal.vue?vue&type=template&id=ed9b1236"
import script from "./AdminPurchaseOrderItemModal.vue?vue&type=script&lang=js"
export * from "./AdminPurchaseOrderItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports